import { RouterProvider } from '@tanstack/react-router'
import { createRoot } from 'react-dom/client'
import { initAuth } from './auth/keycloak'
import { getRouter } from './router'
import './styles.css'

async function bootstrap() {
  await initAuth()
  const router = getRouter()
  createRoot(document.getElementById('root')!).render(
    <RouterProvider router={router} />,
  )
}

void bootstrap()
